import { dummyDocumentPreparation } from './dummy-data/documentPreparation'
import { dummyEvaluationDetail } from './dummy-data/evaluationDetail'
import { dummyKinerjaProfile } from './dummy-data/kinerjaProfile'
import { dummyListGuruStates } from './dummy-data/listGuruStates'
import { dummyObservationImplementation } from './dummy-data/observationImplementation'
import { dummyPelaksanaanProgress } from './dummy-data/pelaksanaanProgress'
import { dummySupportingDocuments } from './dummy-data/supportingDocuments'
import { dummyTargetPerilaku } from './dummy-data/targetPerilaku'

import type { ResponseKinerjaProfil } from 'types/kinerja'
import type { CommonResponse } from 'types/api'
import type {
  ParamsUpsertObservationImplementation,
  ResponseEvaluationDetail,
  ResponseGetListGuruStates,
  ResponseGetObservationImplementation,
  ResponsePelaksanaanDocumentPreparation,
  ResponsePelaksanaanProgress,
  ResponsePelaksanaanTargetPerilaku,
  ResponseSupportingDocument,
} from 'types/kinerja-pelaksanaan'

interface DummyPengelolaanKinerja {
  listGuruStates: CommonResponse<ResponseGetListGuruStates>
  supportingDocuments: CommonResponse<ResponseSupportingDocument>
  evaluationDetail: CommonResponse<ResponseEvaluationDetail>
  pelaksanaanProgress: CommonResponse<ResponsePelaksanaanProgress>
  kinerjaProfile: ResponseKinerjaProfil
  targetPerilaku: CommonResponse<ResponsePelaksanaanTargetPerilaku[]>
  documentPreparation: CommonResponse<ResponsePelaksanaanDocumentPreparation>
  observationImplementation: CommonResponse<ResponseGetObservationImplementation>
}

const localStorageKey = 'DEMO_PENGELOLAAN_KINERJA'

const initialData: DummyPengelolaanKinerja = {
  listGuruStates: dummyListGuruStates,
  supportingDocuments: dummySupportingDocuments,
  evaluationDetail: dummyEvaluationDetail,
  pelaksanaanProgress: dummyPelaksanaanProgress,
  kinerjaProfile: dummyKinerjaProfile,
  targetPerilaku: dummyTargetPerilaku,
  documentPreparation: dummyDocumentPreparation,
  observationImplementation: dummyObservationImplementation,
}

export const reinitialize = () => {
  window.localStorage.setItem(localStorageKey, JSON.stringify(initialData))
}

export const getDummyData = () => {
  const stringData = window.localStorage.getItem(localStorageKey)

  if (!stringData) {
    reinitialize()
  }

  return JSON.parse(window.localStorage.getItem(localStorageKey))
}

export const setDummyData = (key: keyof DummyPengelolaanKinerja, value) => {
  const currentData = getDummyData()
  window.localStorage.setItem(
    localStorageKey,
    JSON.stringify({ ...currentData, [key]: value })
  )
}

export const getListGuruStates = () => getDummyData().listGuruStates
export const getSupportingDocuments = () => getDummyData().supportingDocuments
export const getEvaluationDetail = () => getDummyData().evaluationDetail
export const getPelaksanaanProgress = () => getDummyData().pelaksanaanProgress
export const getKinerjaProfile = () => getDummyData().kinerjaProfile

export const getTargetPerilaku = () => getDummyData().targetPerilaku
export const getDocumentPreparation = () => getDummyData().documentPreparation
export const getObservationImplementation = () =>
  getDummyData().observationImplementation
export const upsertObservationImplementation = (
  params: ParamsUpsertObservationImplementation
) =>
  new Promise((resolve) => {
    const currentPelaksanaanProgress = getPelaksanaanProgress()
    setDummyData('observationImplementation', {
      data: params,
      meta: {},
    })
    setDummyData('pelaksanaanProgress', {
      ...currentPelaksanaanProgress,
      data: {
        ...currentPelaksanaanProgress.data,
        progressPercentage: 50,
      },
    })

    resolve(getDummyData())
  })
